import { useContext } from 'react'
import { UserObjectContext } from './store'
// Services

import Services from './services'
// Actions
import * as Actions from './actions'

const useUserObjectState = () => {
  const [state, dispatch] = useContext(UserObjectContext)
  const store = {
    state: { ...state },
    services:{ ...Services(dispatch, Actions) },
  }

  return store
}

export { useUserObjectState }
